import { Account } from 'api/account';
import { HttpClient } from 'api/http-client';
import { TimesheetSourceType } from '..';
import { Configuration as TimesheetConfiguration } from '../configuration/configuration';

interface CreatedUserInfo {
  userName: string;
  emailId: string;
  userId: number;
  photoUrl?: string;
  firstName: string;
  lastName: string;
  identityType: string;
  createdAt: number;
}

interface CalendarIntegrationMeta {
  oauthAuthenticatorAccountId: string;
  oauthAuthenticatorEmail: string;
  oauthAuthenticatorAccountName: string;
  oauthAuthenticatorAccountProfileUrl: string;
}
export interface CalendarIntegration {
  integrationId: number;
  integrationType: TimesheetSourceType;
  account: Account;
  createdBy: CreatedUserInfo;
  integrationStatus: 'ACTIVE' | 'AUTHENTICATION_EXPIRED';
  meta: CalendarIntegrationMeta;
}
export type CalendarIntegrations = CalendarIntegration[];

export interface AuthMeta {
  authType: string;
  oauthUrl: string;
  oauthReauthUrl: string;
}

const GoogleOauthUrl = '/integration-providers/google_calendar/meta';
const OutlookOauthUrl = '/integration-providers/outlook_calendar/meta';
const GoogleIntegrationUrl = '/integrations/google_calendar';
const OutlookIntegrationUrl = '/integrations/outlook_calendar';
const AccountIntegrationUrl = '/timesheets/configuration';

export type { TimesheetConfiguration };
class CalendarIntegrationProviderHttpClient extends HttpClient {
  getGoogleOauth = (): Promise<AuthMeta> => this.get(GoogleOauthUrl);

  getOutlookOauth = (): Promise<AuthMeta> => this.get(OutlookOauthUrl);

  getGoogleIntegrations = (): Promise<CalendarIntegrations> =>
    this.get(GoogleIntegrationUrl);

  getOutlookIntegrations = (): Promise<CalendarIntegrations> =>
    this.get(OutlookIntegrationUrl);

  deleteIntegration = (integrationId: number) =>
    this.delete(`${GoogleIntegrationUrl}/${integrationId}`);

  getTimesheetConfiguration = (): Promise<TimesheetConfiguration> =>
    this.get(AccountIntegrationUrl);

  updateTimesheetConfiguration = (
    payload: TimesheetConfiguration,
  ): Promise<TimesheetConfiguration> =>
    this.put(AccountIntegrationUrl, payload);
}

export const CalendarIntegrationProviderSetupApi =
  new CalendarIntegrationProviderHttpClient();
